(ns frontend.view.entity-viewers.modules.counterparty-diligences.sub
  (:require
   [re-frame.core :as rf]
   [frontend.view.entity-viewers.modules.counterparty-diligences.model :as model]))

(rf/reg-sub
 ::state
 (fn [db [_ entity-id]]
   (get-in db (conj model/root-path entity-id))))

(rf/reg-sub
 ::associated-counterparty-diligences
 (fn [[_ entity-id]]
   [(rf/subscribe [::state entity-id])])
 (fn [[state] [_ entity-id]]
   (->> state
        model/entities-key
        (filterv
         (fn [candidate]
           (-> candidate
               :project-counterparty-diligence/source-entity
               (= entity-id)))))))

(rf/reg-sub
 ::create-modal-open?
 (fn [[_ entity-id]]
   [(rf/subscribe [::state entity-id])])
 (fn [[state] [_ entity-id]]
   (get state model/create-modal-open-key)))

(rf/reg-sub
 ::submitting?
 (fn [[_ entity-id]]
   [(rf/subscribe [::state entity-id])])
 (fn [[state]]
   (get state model/submitting-key)))
